module.exports = new __parcel__URL__("poh-image.0ff250c0.png").toString();